import React, {useMemo} from 'react';
import _ from 'lodash';

import Link from '../../components/Link';
import {createURLWithParams} from '../../util';

const MAX_PILLS = 12;

const Pill = (props) => (
  <Link
    className={`
      block
      mx-1
      my-1.5
      px-3
      py-2
      border
      border-gray-300
      rounded-full
      bg-gray-50
      whitespace-nowrap
      cursor-pointer
    `}
    {...props}
  />
);

export const TopCompanyQueries = ({
  role, company, tags, className,
}) => {
  const companyTags = tags?.company;
  const queries = useMemo(() => (companyTags || [])
    .filter(({id}) => id !== company?.id)
    .slice(0, MAX_PILLS), [companyTags, company]);

  return queries.length > 0 && (
    <div className={className}>
      <h3 className="text-xl font-bold mb-4">
        {role ? `Explore ${role.name} questions by company` : 'Explore questions by company'}
      </h3>
      <div className="flex flex-wrap -mx-4 px-4 overflow-scroll scrollbar-hidden">
        {queries.map((query) => (
          <Pill href={createURLWithParams('/questions', {company: query.id, role: role?.id})} key={query.id}>
            {role ? `${query.name} ${role.name} Questions` : `${query.name} Questions`}
          </Pill>
        ))}
      </div>
    </div>
  );
};

export const TopRoleQueries = ({
  role, company, tags, className,
}) => {
  const roleTags = tags?.role;
  const queries = useMemo(() => (roleTags || [])
    .filter(({id}) => id !== role?.id)
    .slice(0, MAX_PILLS), [roleTags, role]);

  return queries.length > 0 && (
    <div className={className}>
      <h3 className="text-xl font-bold mb-4">
        {company ? `Explore ${company.name} questions by role` : 'Explore questions by role'}
      </h3>
      <div className="flex flex-wrap -mx-4 px-4 overflow-scroll scrollbar-hidden">
        {queries.map((query) => (
          <Pill href={createURLWithParams('/questions', {role: query.id, company: company?.id})} key={query.id}>
            {company ? `${company.name} ${query.name} Questions` : `${query.name} Questions`}
          </Pill>
        ))}
      </div>
    </div>
  );
};

const SuggestedQueries = ({
  company,
  role,
  tags,
  className,
}) => ((company && !role) ? (
  <div className={className}>
    <TopRoleQueries company={company} tags={tags} className="mb-8" />
    <TopCompanyQueries company={company} tags={tags} />
  </div>
) : (
  <div className={className}>
    <TopCompanyQueries company={company} role={role} tags={tags} className="mb-8" />
    <TopRoleQueries company={company} role={role} tags={tags} />
  </div>
));

export default SuggestedQueries;
